/* eslint-disable react/no-array-index-key */
import { Card, FontIcon, Typography } from "@ezmid/components-library";
import { faRoad } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { useGetUserGoalsByUserIdQuery } from "../../../api/user-goals.generated";

type Props = {
  id: string;
};

export function UserGoalsCard({ id }: Props) {
  const { t } = useTranslation();
  const { currentData } = useGetUserGoalsByUserIdQuery(
    {
      id: id ?? "",
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const userGoal = currentData?.items?.[0];
  const lessonImgUrl = userGoal?.goalImage?.image?.image?.content?.find(
    ({ type }) => type === "square-large"
  )?.url;
  const goalWords = userGoal?.goalWords;

  return (
    <Card
      shadows="lg"
      size="fill"
      hasBorder={false}
      headerText={t("user.goals.information")}
      headerIcon={
        <FontIcon
          marginTop={4}
          customIcon={<FontAwesomeIcon size="lg" icon={faRoad} />}
        />
      }
    >
      <div className="flex justify-center">
        <img
          className="object-cover w-full h-96 md:h-auto md:w-48"
          src={lessonImgUrl}
          alt=""
        />
        <div className="flex flex-col justify-center p-4 leading-normal">
          <Typography variant="h5">{userGoal?.sentence}</Typography>
          <ul className="pt-2">
            {goalWords?.map((word, index) => {
              return (
                <Typography key={index} variant="body1">
                  {word},{" "}
                </Typography>
              );
            })}
          </ul>
        </div>
      </div>
    </Card>
  );
}
